import "./AdvocacyEducation.module.css";
import Header from "@/reusable_sections/Header";
import Protection from "./sections/Protection";
import Resources from "./sections/Resources";
import Engagement from "./sections/Engagement";
import Footer from "@/reusable_sections/Footer";
export default function AdvocacyEducationPage() {
  return <div>
      <Header />
      <Protection />
      <Resources />
      <Engagement />
      <Footer />
    </div>;
}